// Pill switch between "Hold to speak" (ptt) and "Hands-free" (handsfree).
export default function ModeToggle({ mode, onChange, disabled }) {
  const options = [
    { key: "ptt", label: "Hold to speak" },
    { key: "handsfree", label: "Hands-free" },
  ];
  return (
    <div
      role="tablist"
      aria-label="Conversation mode"
      data-testid="mode-toggle"
      className="relative inline-flex items-center rounded-full p-1"
      style={{
        background: "hsla(0,0%,100%,0.7)",
        border: "1px solid hsla(38,25%,80%,0.7)",
        boxShadow: "inset 0 1px 0 hsla(0,0%,100%,0.9)",
        opacity: disabled ? 0.5 : 1,
      }}
    >
      {options.map((opt) => {
        const active = mode === opt.key;
        return (
          <button
            key={opt.key}
            type="button"
            role="tab"
            aria-selected={active}
            disabled={disabled}
            data-testid={`mode-${opt.key}`}
            onClick={() => !disabled && onChange?.(opt.key)}
            className="relative z-10 rounded-full px-4 py-2 text-xs font-medium transition-colors"
            style={{
              color: active ? "hsl(43 45% 96%)" : "hsl(30 9% 38%)",
              background: active ? "hsl(36 10% 9%)" : "transparent",
              minHeight: 32,
            }}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
